import { AnyAction } from 'redux'
import { produce } from 'immer'
import { PaginateRequest, PaginateResponse } from '../../services/api.service'
import customLabelPrintService from '../../services/customLabelPrint.service'
import { CustomLabelPrintData } from '../../apis/customLabelPrint.api'

interface State extends PaginateRequest {
  id: number | null
  result: PaginateResponse<CustomLabelPrintData[]>
  search: string
  startAt: string
  endAt: string
}

const initialState: State = {
  id: null,
  result: {
    data: [],
    total: 0,
    from: null,
    to: null,
    currentPage: 0,
    lastPage: 0
  },
  page: 1,
  limit: 25,
  search: '',
  startAt: '',
  endAt: ''
}

export const actions = {
  replaceId: 'customLabelPrintsPaginate/replaceId',
  replaceResult: 'customLabelPrintsPaginate/replaceResult',
  replaceResultData: 'customLabelPrintsPaginate/replaceResultData',
  replacePage: 'customLabelPrintsPaginate/replacePage',
  replaceLimit: 'customLabelPrintsPaginate/replaceLimit',
  replaceSearch: 'customLabelPrintsPaginate/replaceSearch',
  replaceFilters: 'customLabelPrintsPaginate/replaceFilters'
}

export function replaceId (id: number) {
  return { type: actions.replaceId, id }
}

export function replaceResult (result: State['result']) {
  return { type: actions.replaceResult, result }
}

export function replaceResultData (data: State['result']['data']) {
  return { type: actions.replaceResultData, data }
}

export function replacePage (page: number) {
  return { type: actions.replacePage, page }
}

export function replaceLimit (limit: number) {
  return { type: actions.replaceLimit, limit }
}

export function replaceSearch (search: string) {
  return { type: actions.replaceSearch, search }
}

export function replaceFilters (search: string, startAt: string, endAt: string) {
  return { type: actions.replaceFilters, search, startAt, endAt }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.replaceId:
      return produce(state, draft => {
        draft.id = action.id
      })
    case actions.replaceResult:
      return produce(state, draft => {
        draft.result = action.result
        draft.result.data = customLabelPrintService.tableHorizontalData(action.result.data)
      })
    case actions.replaceResultData:
      return produce(state, draft => {
        draft.result.data = action.data
      })
    case actions.replacePage:
      return produce(state, draft => {
        draft.page = action.page
      })
    case actions.replaceLimit:
      return produce(state, draft => {
        draft.limit = action.limit
        draft.page = 1
      })
    case actions.replaceSearch:
      return produce(state, draft => {
        draft.search = action.search
        draft.page = 1
      })
    case actions.replaceFilters:
      return produce(state, draft => {
        draft.search = action.search
        draft.startAt = action.startAt
        draft.endAt = action.endAt
        draft.page = 1
      })
    default:
      return state
  }
}
